// extracted by mini-css-extract-plugin
var _1 = "LabelSelectDropdownListFooter-moduleLabelSelectDropdownListFooter__QzjVo SelectDropdownListFooter-moduleSelectDropdownListFooter__Cqw_A";
var _2 = "LabelSelectDropdownListFooter-moduleaddNewLabelButton__rSl7I";
export { _1 as "LabelSelectDropdownListFooter", _2 as "addNewLabelButton" }
